import SearchContainerCommon from './common/search-container-common';

const showClearButton = (keyword: string, inSearchRoute: boolean) => !!(keyword && inSearchRoute);

const SearchContainer = () => <SearchContainerCommon showClearButton={showClearButton} />;

export default SearchContainer;
